import Left from './Left';

export default Left;
